export const national_strategic_planning_development = [
  {
    id: 1,
    name: 'A-Just-Transition-Framework-for-South-Africa-2022',
    summary: 'shortsummary/A-Just-Transition-Framework-for-South-Africa-2022.html',
    link: 'A-Just-Transition-Framework-for-South-Africa-2022.pdf',
    audio_en: 'audio/en/A-Just-Transition-Framework-for-South-Africa-2022_en.mp3',
    audio_af: 'audio/af/A-Just-Transition-Framework-for-South-Africa-2022_af.mp3',
    audio_xh: 'audio/xh/A-Just-Transition-Framework-for-South-Africa-2022_xh.mp3'
  },
  {
    id: 2,
    name: 'BDM Booklet 1',
    summary: 'shortsummary/BDM Booklet 1.html',
    link: 'BDM Booklet 1.pdf',
    audio_en: 'audio/en/BDM_Booklet_1_en.mp3',
    audio_af: 'audio/af/BDM_Booklet_1_af.mp3',
    audio_xh: 'audio/xh/BDM_Booklet_1_xh.mp3'
  },
  {
    id: 3,
    name: 'IUDF-2016_WEB-min',
    summary: 'shortsummary/IUDF-2016_WEB-min.html',
    link: 'IUDF-2016_WEB-min.pdf',
    audio_en: 'audio/en/IUDF-2016_WEB-min_en.mp3',
    audio_af: 'audio/af/IUDF-2016_WEB-min_af.mp3',
    audio_xh: 'audio/xh/IUDF-2016_WEB-min_xh.mp3'
  },
  {
    id: 4,
    name: 'Medium Term Budget Policy Statement 24_25',
    summary: 'shortsummary/Medium Term Budget Policy Statement 24_25.html',
    link: 'Medium Term Budget Policy Statement 24_25.pdf',
    audio_en: 'audio/en/Medium_Term_Budget_Policy_Statement_24_25_en.mp3',
    audio_af: 'audio/af/Medium_Term_Budget_Policy_Statement_24_25_af.mp3',
    audio_xh: 'audio/xh/Medium_Term_Budget_Policy_Statement_24_25_xh.mp3'
  },
  {
    id: 5,
    name: 'Medium Term Expenditure Framework',
    summary: 'shortsummary/Medium Term Expenditure Framework.html',
    link: 'Medium Term Expenditure Framework.pdf',
    audio_en: 'audio/en/Medium_Term_Expenditure_Framework_en.mp3',
    audio_af: 'audio/af/Medium_Term_Expenditure_Framework_af.mp3',
    audio_xh: 'audio/xh/Medium_Term_Expenditure_Framework_xh.mp3'
  },
  {
    id: 6,
    name: 'MOIP-challenges-and-opportunities-working-paper-2017-1.pdf',
    summary: 'shortsummary/MOIP-challenges-and-opportunities-working-paper-2017-1.html',
    link: 'MOIP-challenges-and-opportunities-working-paper-2017-1.pdf',
    audio_en: 'audio/en/MOIP-challenges-and-opportunities-working-paper-2017-1_en.mp3',
    audio_af: 'audio/af/MOIP-challenges-and-opportunities-working-paper-2017-1_af.mp3',
    audio_xh: 'audio/xh/MOIP-challenges-and-opportunities-working-paper-2017-1_xh.mp3'
  },
  {
    id: 7,
    name: 'MTFonSPPReportCSD19FINAL',
    summary: 'shortsummary/MTFonSPPReportCSD19FINAL.html',
    link: 'MTFonSPPReportCSD19FINAL.pdf',
    audio_en: 'audio/en/MTFonSPPReportCSD19FINAL_en.mp3',
    audio_af: 'audio/af/MTFonSPPReportCSD19FINAL_af.mp3',
    audio_xh: 'audio/xh/MTFonSPPReportCSD19FINAL_xh.mp3'
  },
  {
    id: 8,
    name: 'NDP-2030-our-future-make-it-workr',
    summary: 'shortsummary/NDP-2030-our-future-make-it-workr.html',
    link: 'NDP-2030-our-future-make-it-workr.pdf',
    audio_en: 'audio/en/NDP-2030-our-future-make-it-workr_en.mp3',
    audio_af: 'audio/af/NDP-2030-our-future-make-it-workr_af.mp3',
    audio_xh: 'audio/xh/NDP-2030-our-future-make-it-workr_xh.mp3'
  },
  {
    id: 9,
    name: 'NIP 2050',
    summary: 'shortsummary/NIP 2050.html',
    link: 'NIP 2050.pdf',
    audio_en: 'audio/en/NIP 2050_en.mp3',
    audio_af: 'audio/af/NIP 2050_af.mp3',
    audio_xh: 'audio/xh/NIP 2050_xh.mp3'
  },
  {
    id: 10,
    name: 'NSDF',
    summary: 'shortsummary/NSDF.html',
    link: 'NSDF.pdf',
    audio_en: 'audio/en/NSDF_en.mp3',
    audio_af: 'audio/af/NSDF_af.mp3',
    audio_xh: 'audio/xh/NSDF_xh.mp3'
  },
  {
    id: 11,
    name: 'SDG_Country_report',
    summary: 'shortsummary/SDG_Country_report.html',
    link: 'SDG_Country_report.pdf',
    audio_en: 'audio/en/SDG_Country_report_en.mp3',
    audio_af: 'audio/af/SDG_Country_report_af.mp3',
    audio_xh: 'audio/xh/SDG_Country_report_xh.mp3'
  },
  {
    id: 12,
    name: 'SPLUMA',
    summary: 'shortsummary/SPLUMA.html',
    link: 'SPLUMA.pdf',
    audio_en: 'audio/en/SPLUMA_en.mp3',
    audio_af: 'audio/af/SPLUMA_af.mp3',
    audio_xh: 'audio/xh/SPLUMA_xh.mp3'
  },
  {
    id: 13,
    name: 'Western_cape_strategic_plan_2019-2024 (PSP)',
    summary: 'shortsummary/western_cape_strategic_plan_2019-2024 (PSP).html',
    link: 'PSP_western_cape_strategic_plan_2019-2024 (PSP).pdf',
    audio_en: 'audio/en/PSP_western_cape_strategic_plan_2019-2024_(PSP)_en.mp3',
    audio_af: 'audio/af/PSP_western_cape_strategic_plan_2019-2024_(PSP)_af.mp3',
    audio_xh: 'audio/xh/PSP_western_cape_strategic_plan_2019-2024_(PSP)_xh.mp3'
  }
];